module.exports = __webpack_public_path__ + "img/right_arrow.45e33a59.svg";